import React from "react";
import {findDOMNode} from "react-dom";

import UI5CalendarRange from "../../../../../../gd-components/datetime/calendar-v2/calendar-range";
import Popover from "../../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position";
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const";

const popoverPosition = new PopoverPosition({
    attachment      : "top center",
    targetAttachment: "bottom center",
    attachmentType  : PopoverAttachmentType.FULL,
})

export default function FieldDateRange_Popover(props:any) {

    const onSelect = (dateRange:any) => {
        props.parent.hidePopover();
        props.parent.onValueChange(dateRange);
    }

    let value = null
    if (props.parent.state?.currentValue) {
        value = props.parent.state.currentValue
    } else {
        value = props.parent.value // fix for editable case ?
    }

    return (
        <Popover className="daterange-picker-popover" position={popoverPosition}
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            <UI5CalendarRange selectedRange = {value}
                              minDate       = {props.field.minDate}
                              maxDate       = {props.field.maxDate}
                              presets       = {false}
                              onSelect      = {onSelect}/>
        </Popover>
    );
}